import { render, staticRenderFns } from "./input-scan.vue?vue&type=template&id=6bd9200b&scoped=true"
import script from "./input-scan.vue?vue&type=script&lang=js"
export * from "./input-scan.vue?vue&type=script&lang=js"
import style0 from "./input-scan.vue?vue&type=style&index=0&id=6bd9200b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9200b",
  null
  
)

export default component.exports